<template>
    <div class="channel-overview-container">
        <header>
            <div class="channel-info">
                <div class="channel-thumbnail">
                    <Skeleton v-if="!thumbnailUrl" width="64" height="64" />
                    <img v-else :src="thumbnailUrl" :alt="title + ' Channel Thumbnail'" />
                </div>
                <div>
                    <Text>{{ title }}</Text>
                    <Text size="f-8" class="o-60">
                        <oNumber :value="subscribers" :compact="true" />
                        <span class="channel-subscribers">subscribers</span>
                    </Text>
                </div>
            </div>
            <div class="youtube-logo">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="105"
                    height="23"
                    viewBox="0 0 105 23"
                    fill="none"
                >
                    <path
                        d="M32.635 3.592A4.145 4.145 0 0 0 29.688.687C27.09 0 16.666 0 16.666 0S6.242 0 3.644.687A4.145 4.145 0 0 0 .697 3.592C0 6.153 0 11.5 0 11.5s0 5.347.697 7.908a4.145 4.145 0 0 0 2.947 2.905C6.242 23 16.666 23 16.666 23s10.424 0 13.022-.687a4.144 4.144 0 0 0 2.947-2.905c.697-2.561.697-7.908.697-7.908s-.003-5.347-.697-7.908Z"
                        fill="red"
                    />
                    <path d="m13.33 16.428 8.66-4.928-8.66-4.927v9.855Z" fill="#fff" />
                    <path
                        d="M40.37 14.954 36.627 1.631h3.265l1.312 6.04c.334 1.487.579 2.756.738 3.805h.096c.11-.752.357-2.012.738-3.784l1.358-6.06h3.265l-3.79 13.322v6.391h-3.242v-6.39h.003ZM48.381 20.923c-.658-.438-1.127-1.12-1.407-2.045-.277-.925-.417-2.153-.417-3.689v-2.09c0-1.55.159-2.797.477-3.736.318-.938.815-1.625 1.49-2.055.675-.43 1.561-.647 2.659-.647 1.08 0 1.945.22 2.598.658.65.438 1.128 1.125 1.43 2.055.301.933.452 2.175.452 3.724v2.091c0 1.536-.148 2.77-.441 3.7-.294.933-.772 1.615-1.43 2.045-.659.43-1.553.646-2.68.646-1.164.003-2.072-.22-2.73-.657Zm3.693-2.256c.181-.47.275-1.236.275-2.301v-4.487c0-1.034-.09-1.79-.275-2.267-.183-.479-.504-.717-.965-.717-.445 0-.76.238-.942.717-.183.479-.274 1.233-.274 2.267v4.487c0 1.065.088 1.833.264 2.301.175.47.49.706.952.706.46 0 .782-.235.965-.706ZM66.284 21.348H63.71l-.285-1.764h-.072c-.7 1.331-1.748 1.996-3.147 1.996-.968 0-1.684-.313-2.145-.938-.461-.627-.692-1.607-.692-2.937V6.943h3.29v10.572c0 .644.071 1.101.214 1.374.143.274.381.411.716.411.285 0 .56-.086.823-.26.264-.172.456-.391.585-.656V6.94h3.287v14.408Z"
                        fill="#111"
                    />
                    <path
                        d="M75.221 4.24h-3.265v17.107h-3.218V4.241h-3.265V1.633h9.748v2.608Z"
                        fill="#111"
                    />
                    <path
                        d="M83.157 21.348h-2.574l-.285-1.764h-.072c-.7 1.331-1.747 1.996-3.147 1.996-.968 0-1.684-.313-2.145-.938-.461-.627-.692-1.607-.692-2.937V6.943h3.29v10.572c0 .644.071 1.101.214 1.374.143.274.381.411.716.411.285 0 .56-.086.823-.26.264-.172.456-.391.585-.656V6.94h3.287v14.408ZM94.044 9.245c-.2-.91-.521-1.566-.965-1.975-.445-.408-1.057-.611-1.836-.611-.604 0-1.169.168-1.693.506-.524.338-.93.779-1.216 1.328h-.024V.903h-3.17v20.442h2.717l.335-1.363h.071c.255.487.637.868 1.144 1.152a3.436 3.436 0 0 0 1.693.422c1.111 0 1.932-.506 2.456-1.515.524-1.011.787-2.588.787-4.735v-2.28c0-1.61-.101-2.873-.299-3.781Zm-3.015 5.877c0 1.049-.044 1.871-.132 2.466-.088.595-.233 1.02-.442 1.269-.205.251-.485.376-.834.376-.271 0-.521-.063-.752-.19a1.426 1.426 0 0 1-.56-.562v-8.176a2.02 2.02 0 0 1 .574-.963c.27-.252.565-.376.88-.376.336 0 .594.13.775.387.184.26.31.692.381 1.303.071.612.107 1.48.107 2.607v1.859h.003ZM99.01 15.952c0 .925.028 1.617.083 2.08.055.462.17.798.346 1.011.175.211.444.317.809.317.491 0 .831-.19 1.013-.566.183-.375.282-1.003.299-1.88l2.837.166c.016.124.024.297.024.516 0 1.331-.37 2.326-1.108 2.983-.738.658-1.784.988-3.134.988-1.621 0-2.757-.5-3.407-1.504-.653-1.003-.977-2.553-.977-4.652v-2.515c0-2.161.337-3.74 1.012-4.736.675-.995 1.83-1.493 3.469-1.493 1.127 0 1.994.203 2.598.611.604.409 1.029 1.042 1.276 1.904.247.863.37 2.053.37 3.573v2.467h-5.51v.73Zm.418-6.789c-.168.203-.277.536-.335.998-.055.463-.082 1.163-.082 2.105v1.033h2.406v-1.033c0-.925-.033-1.626-.096-2.105-.063-.478-.178-.814-.346-1.011-.167-.195-.425-.295-.774-.295-.35.003-.609.106-.773.308Z"
                        fill="#111"
                    />
                </svg>
            </div>
        </header>
        <Spacer v-if="description" height="2rem" />
        <Text v-if="description" size="f-8" class="channel-description">{{ description }}</Text>
        <Spacer v-if="topics && topics.length > 0" height="2rem" />
        <div v-if="topics && topics.length > 0">
            <Label>Channel Topics</Label>
            <perfect-scrollbar class="topics-container">
                <ColorTag v-for="topic in topics" :key="topic" :title="topic" />
            </perfect-scrollbar>
        </div>
        <Spacer height="2rem" />
        <div class="channel-overview-btn-container">
            <a :href="channelUrl" target="_blank">
                <oButton color="white">View Channel</oButton>
            </a>
        </div>
    </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'

import {
    // Components
    Text,
    Spacer,
    oImage,
    Number as oNumber,
    Label,
    ColorTag,
    oButton,
} from '@opteo/components-next'

import Skeleton from '@/components/util/Skeleton.vue'

interface YoutubeChannel {
    title: string
    description: string
    subscribers: number
    thumbnailUrl: string
    topics: string[]
}

const props = defineProps({
    title: {
        type: String as PropType<string>,
        required: true,
    },
    description: {
        type: String as PropType<string>,
        required: true,
    },
    subscribers: {
        type: Number as PropType<number>,
        required: true,
    },
    thumbnailUrl: {
        type: String as PropType<string>,
        required: true,
    },
    topics: {
        type: Array as PropType<string[] | undefined>,
        required: true,
    },
    channelUrl: {
        type: String as PropType<string>,
        required: true,
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.channel-overview-container {
    @include container;
    @include br-28;
    width: 100%;
    max-width: 604px;
    @include pa-48;
}
header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include relative;
}
.channel-info {
    display: flex;
    align-items: center;
    gap: 1rem;
}
.channel-thumbnail {
    height: 4rem;
    width: 4rem;
    overflow: hidden;
    border-radius: 100%;
    flex-shrink: 0;
}
.channel-subscribers {
    margin-left: 0.25rem;
}
.channel-description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.topics-container {
    @include container;
    @include br-20;
    @include ph-20;
    @include pv-16;
    width: 100%;
    white-space: nowrap;
    @include flex;
    @include items-center;
    gap: 0.375rem;
}
.channel-overview-btn-container {
    @include flex-center;
}

@media screen and (max-width: $mq-480-max) {
    .channel-overview-container {
        @include pa-24;
    }

    .topics-container {
        @include pa-16;
    }
}

@media screen and (max-width: 600px) {
    header {
        flex-direction: column-reverse;
        @include justify-end;
    }
    .channel-info {
        margin-top: 2.5rem;
        width: 100%;
    }
    .youtube-logo {
        @include absolute;
        top: 0;
        right: 0;
    }
}
</style>
